<template>
  <div class="device">
    <el-tabs v-model="activeName">
      <el-tab-pane label="重点设备" name="1">
        <FocusDev v-if="activeName=='1'"></FocusDev>
      </el-tab-pane>
      <el-tab-pane label="新装设备" name="2">
        <NewDev v-if="activeName=='2'"></NewDev>
      </el-tab-pane>
      <el-tab-pane label="设备状态" name="3">
        <DeviceStatus v-if="activeName=='3'"></DeviceStatus>
      </el-tab-pane>
      <el-tab-pane label="实时状态" name="4">
        <NowTime v-if="activeName=='4'"></NowTime>
      </el-tab-pane>
      <el-tab-pane label="运行记录" name="5">
        <RunRecord v-if="activeName=='5'"></RunRecord>
      </el-tab-pane>
      <el-tab-pane label="物联网设备" name="6">
        <NetThings v-if="activeName=='6'"></NetThings>
      </el-tab-pane>
      <el-tab-pane label="运行提示" name="7">
        <RunPoint v-if="activeName=='7'"></RunPoint>
      </el-tab-pane>
      <el-tab-pane label="运维团队" name="8">
        <Team v-if="activeName=='8'"></Team>
      </el-tab-pane>
      <el-tab-pane label="设备检修计划" name="9">
        <ServicePlan v-if="activeName=='9'"></ServicePlan>
      </el-tab-pane>
      <el-tab-pane label="备件更换率" name="10">
        <ReplaceRate v-if="activeName=='10'"></ReplaceRate>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import FocusDev from './focusDevice'
import NewDev from './newDevice'
import DeviceStatus from './deviceStatus'
import NowTime from './nowTimeStatus'
import Team from './team'
import RunRecord from './runRecord'
import NetThings from './netThings'
import RunPoint from './runPoint'
import ServicePlan from './devServicePlan'
import ReplaceRate from './spReplaceRate'
export default {
  components: {
    FocusDev,
    NewDev,
    DeviceStatus,
    NowTime,
    Team,
    RunRecord,
    NetThings,
    RunPoint,
    ServicePlan,
    ReplaceRate,
  },
  data() {
      return {
        activeName: '1'
      }
  },
  mounted() {},
  methods: {
    // handleClick(tab, event) {
    //   console.log(tab, event);
    // }
  },
}
</script>

<style lang="less">
.device { height: 100%; overflow: hidden;
  .trend-title{ display: inline-block; width: 6rem; text-align: right; height: 1.8rem; padding:0 .8rem; line-height: 1.8rem; font-size: .8rem; background: #3570ff;}
  .avatar,.avatar-uploader{ width: 8rem; height: 6rem; border: #3570ff solid 1px;}
  .avatar-uploader{ color: #fff; text-align:center; line-height: 6rem; font-size: 2rem;}
  .last-save{ margin-top: 2rem;}
}
</style>